
export function render(_ctx, _cache) {
  return null
}
export default { render: render }